export default [
    { key: 0, value: "None" },
    { key: 1, value: "Productive" },
    { key: 2, value: "Unproductive" },
    { key: 3, value: "Setup" }

]